import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = {
  key: 0,
  class: "contentBox"
}
const _hoisted_3 = { class: "block w-full" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_5 = { class: "inputTitle" }
const _hoisted_6 = { class: "inputField flex-grow" }
const _hoisted_7 = { class: "inputTitle" }
const _hoisted_8 = { class: "inputField flex-grow" }
const _hoisted_9 = { class: "inputTitle" }
const _hoisted_10 = { class: "inputField flex-grow" }
const _hoisted_11 = { class: "inputTitle" }
const _hoisted_12 = { class: "inputField flex-grow" }
const _hoisted_13 = { class: "inputTitle" }
const _hoisted_14 = { class: "inputField flex-grow" }
const _hoisted_15 = { class: "inputTitle" }
const _hoisted_16 = { class: "inputField flex-grow" }
const _hoisted_17 = { class: "contentBox" }
const _hoisted_18 = { class: "block w-full" }
const _hoisted_19 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_20 = { class: "inputTitle" }
const _hoisted_21 = { class: "inputField flex-grow" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "inputTitle" }
const _hoisted_24 = { class: "inputField flex-grow" }
const _hoisted_25 = { class: "contentBox" }
const _hoisted_26 = { class: "block w-full" }
const _hoisted_27 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_28 = { class: "inputTitle" }
const _hoisted_29 = { class: "inputField flex-grow" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "error-msg" }
const _hoisted_32 = { class: "inputTitle" }
const _hoisted_33 = { class: "inputField flex-grow" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "error-msg" }
const _hoisted_36 = { class: "inputTitle" }
const _hoisted_37 = { class: "inputField flex-grow" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "error-msg" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "smallText mt-4" }
const _hoisted_42 = { class: "pl-4 pt-4" }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = { class: "contentBox" }
const _hoisted_45 = { class: "block w-full" }
const _hoisted_46 = { class: "grid grid-cols-2 gap-4 w-full" }

import {useGlobalStore} from '@/stores/GlobalStore'
import getBrowserLocale from '@/utilities/helpers/GetBrowserLanguage'
import {ErrorLocationType, PreferenceType} from '@/utilities/enums/Enums';
import Text from "@/components/inputs/Text";
import {helpers, minLength, required, sameAs} from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import {computed, onMounted, reactive, Ref, ref} from "vue";
import {$t, i18n} from "@/utilities/i18n/config";
import Error from "@/components/Error";
import moment from 'moment';
import router from '@/router';
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {UserPreference} from "@/models/user/UserPreference";
import {forbiddenStartupRouteNames} from "@/AppConfig";
import {PermissionService} from "@/utilities/services/PermissionService";
import PolicyHelper from "@/utilities/helpers/PolicyHelper";
import {RouteRecordNormalized} from "vue-router";
import {AccountService} from "@/utilities/services/entities/AccountService";
import {UserService} from "@/utilities/services/entities/UserService";
import {useI18n} from "vue-i18n";
import TextOrSpinner from "@/components/TextOrSpinner.vue";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";



export default /*@__PURE__*/_defineComponent({
  __name: 'Account',
  setup(__props) {

const { t } = useI18n();
const globalStore = useGlobalStore();
const accountService = new AccountService();
const userService = new UserService();
const permissionService = new PermissionService();

let showChangePasswordError = ref(false);
let changePasswordError = ref(null);
const loading:Ref<boolean> = ref(false);
const availableRoutes:Ref<RouteRecordNormalized[]> = ref([]);

const passwordChangedMoment = computed(()=>{
  return moment(globalStore.user?.lastPasswordChange).format('DD.MM.YYYY HH:mm') ?? ""
})

const form = reactive({
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
})
const newPasswordRules = computed(() => {

	const hasNoneAlphaNum = helpers.regex(/\W/);
	const hasNumber = helpers.regex(/\d/);
	const hasUppercaseLetter = helpers.regex(/[A-Z]/);
	const hasLowercaseLetter = helpers.regex(/[a-z]/);

  return {
    oldPassword: { required: helpers.withMessage($t('validators.required'), required), },
    newPassword: {
			required: helpers.withMessage(t('validators.required'), required),
			minLength: helpers.withMessage(t('validators.minLength', {amount: 8}), minLength(8)),
			hasNoneAlphaNum: helpers.withMessage(t('validators.hasNoneAlphaNum'), hasNoneAlphaNum),
			hasNumber: helpers.withMessage(t('validators.hasNumber'), hasNumber),
			hasUppercaseLetter: helpers.withMessage(t('validators.hasUppercaseLetter'), hasUppercaseLetter),
			hasLowercaseLetter: helpers.withMessage(t('validators.hasLowercaseLetter'), hasLowercaseLetter),
		},
    confirmPassword: {
      required: helpers.withMessage($t('validators.required'), required),
      sameAsPassword: helpers.withMessage($t('validators.sameAs'), sameAs(form.newPassword)),
    },
  }
})
const v$ = useVuelidate(newPasswordRules, form);


const changeUserStartPage = async({target}:any)=>{
  globalStore.userPreferences.general.userStartPage = target.value;

  await updateGeneralPreferences();

  globalStore.showSuccess($t('settings.startPageSaved'));
}

const changeUserLocale = async({target}:any)=>{
  globalStore.userPreferences.general.userLocale = target.value;
  i18n.global.locale.value = target.value;

  await updateGeneralPreferences();

  globalStore.showSuccess($t('settings.languageSaved'));
}

const updateGeneralPreferences = async ()=>{
  const prefList = [];

  // go through general prefs in globalStore and use reflection to fill array with UserPreference objects
  for (const keyValueArray of Object.entries(globalStore.userPreferences.general)){
    // skip darkMode if it is set to FALSE to make automatism in Login.vue work
    if(keyValueArray[0] === "darkMode" && !keyValueArray[1]) continue;

    let converted = new UserPreference();
    converted.attributeName = keyValueArray[0];
    // @ts-expect-error
    converted.attributeValue = keyValueArray[1];

    prefList.push(converted);
  }

  // @ts-expect-error
  const preferenceUpdateResp = await userService.setUserPreferences(globalStore.user.id, PreferenceType.general, "", false, prefList);
  if (preferenceUpdateResp === null || preferenceUpdateResp === undefined || preferenceUpdateResp.statusCode !== 0){
    ErrorHandler.handleError(preferenceUpdateResp , ErrorLocationType.form);
    return;
  }
}

const isValidStartUpPage = (route:any) => {
  return !forbiddenStartupRouteNames.includes(route.name);
}

const isPermittedForRoute = (route:any) => {
  if(route.name === "Account") return true;
  const permissionString = PolicyHelper.getPolicyFromRoute(route.path);
  return permissionService.userHasPermission(permissionString);
}

onMounted(async ()=>{
  availableRoutes.value = router.getRoutes()
      .filter(or => isValidStartUpPage(or))
      .filter(r => isPermittedForRoute(r))
})

const logoutUser = async () =>{
  const resp = await accountService.logout();

  if(resp === null || resp === undefined || resp?.statusCode !== 0){
    ErrorHandler.handleError(resp, ErrorLocationType.table);
    return;
  }

  globalStore.user = null;
  globalStore.token = "";

  globalStore.resetState();

  await router.push("/logout");
};

const updateUserInGlobalStore = async ()=>{
  const user = await userService.getUserById(globalStore.user.id, ErrorLocationType.login);
  if(NullOrUndefinedHelper(user)) return;

  globalStore.setUser(user);
}

const resetPassword = async () => {
  loading.value = true;
  showChangePasswordError.value = false;

  const isFormCorrect = await v$.value.$validate()
  if (!isFormCorrect) {
    // VALIDATOR ERROR
    loading.value = false;
    return
  }

  // @ts-expect-error
  const resp = await accountService.changePassword(globalStore.user.id, form.oldPassword, form.newPassword, form.confirmPassword);

  if(resp === null || resp === undefined || resp.statusCode !== 0){
    // @ts-expect-error
    changePasswordError.value = resp;
    showChangePasswordError.value = true;

    // @ts-expect-error
    globalStore.error.type = "error";
    globalStore.error.text = resp?.statusDescription;
    // @ts-expect-error
    globalStore.error.code = resp?.statusCode;
    globalStore.error.location = ErrorLocationType.form;

    loading.value = false;
    return;
  }

  else {
    // Password changed
    globalStore.showSuccess($t('account.passwordReset'));
    loading.value = false;
    form.oldPassword = "";
    form.newPassword = "";
    form.confirmPassword = "";
    v$.value.$reset();

    await updateUserInGlobalStore();
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_unref($t)('account.myAccount')), 1)
    ]),
    (_unref(globalStore).user != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h4", null, _toDisplayString(_unref($t)('account.user')), 1),
            _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref($t)('account.firstName')), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(Text), {
                    modelValue: _unref(globalStore).user.firstName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(globalStore).user.firstName) = $event)),
                    disabled: "disabled"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref($t)('account.lastName')), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(Text), {
                    modelValue: _unref(globalStore).user.lastName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(globalStore).user.lastName) = $event)),
                    disabled: "disabled"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_unref($t)('account.email')), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(Text), {
                    modelValue: _unref(globalStore).user.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(globalStore).user.email) = $event)),
                    disabled: "disabled"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref($t)('account.username')), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_unref(Text), {
                    modelValue: _unref(globalStore).user.email,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(globalStore).user.email) = $event)),
                    disabled: "disabled"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref($t)('account.roles')), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_unref(Text), {
                    modelValue: _unref(globalStore).user.roles,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(globalStore).user.roles) = $event)),
                    disabled: "disabled"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_unref($t)('account.kid')), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_unref(Text), {
                    modelValue: _unref(globalStore).user.kid,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(globalStore).user.kid) = $event)),
                    disabled: "disabled"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("h4", null, _toDisplayString(_unref($t)('account.settings')), 1),
        _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_unref($t)('account.startpage')), 1),
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(globalStore).userPreferences.general.userStartPage) = $event)),
                onChange: changeUserStartPage
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableRoutes.value, ({path, name}) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: path,
                    key: path
                  }, _toDisplayString(_unref($t)(`sidebar.${name}`)), 9, _hoisted_22))
                }), 128))
              ], 544), [
                [_vModelSelect, _unref(globalStore).userPreferences.general.userStartPage]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_23, _toDisplayString(_unref($t)('account.language')) + " (" + _toDisplayString(_unref($t)('account.browserLanguage')) + ": " + _toDisplayString(_unref(getBrowserLocale)()) + " (" + _toDisplayString(_unref(getBrowserLocale)({ countryCodeOnly: true })) + ")) ", 1),
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(globalStore).userPreferences.general.userLocale) = $event)),
                onChange: changeUserLocale
              }, _cache[12] || (_cache[12] = [
                _createElementVNode("option", { value: "de" }, "Deutsch", -1),
                _createElementVNode("option", { value: "en" }, "Englisch", -1)
              ]), 544), [
                [_vModelSelect, _unref(globalStore).userPreferences.general.userLocale]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("h4", null, _toDisplayString(_unref($t)('account.passwordTitle')), 1),
        _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_28, _toDisplayString(_unref($t)('account.passwordCurrent')), 1),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", {
                class: _normalizeClass({ error: _unref(v$).oldPassword.$errors.length })
              }, [
                _withDirectives(_createElementVNode("input", {
                  disabled: loading.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.oldPassword) = $event)),
                  class: "form-control w-full",
                  type: "password",
                  placeholder: "Passwort*",
                  autocomplete: "old-password",
                  required: ""
                }, null, 8, _hoisted_30), [
                  [_vModelText, form.oldPassword]
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).oldPassword.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ], 2)
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("div", _hoisted_32, _toDisplayString(_unref($t)('account.passwordNew')), 1),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", {
                class: _normalizeClass({ error: _unref(v$).newPassword.$errors.length })
              }, [
                _withDirectives(_createElementVNode("input", {
                  disabled: loading.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.newPassword) = $event)),
                  class: "form-control w-full",
                  type: "password",
                  placeholder: "Neues Passwort*",
                  autocomplete: "new-password",
                  required: ""
                }, null, 8, _hoisted_34), [
                  [_vModelText, form.newPassword]
                ]),
                _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).newPassword.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, [
                    _createElementVNode("div", _hoisted_35, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ], 2)
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("div", _hoisted_36, _toDisplayString(_unref($t)('account.passwordRepeat')), 1),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", {
                class: _normalizeClass({ error: _unref(v$).confirmPassword.$errors.length })
              }, [
                _withDirectives(_createElementVNode("input", {
                  disabled: loading.value,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.confirmPassword) = $event)),
                  class: "form-control w-full",
                  type: "password",
                  placeholder: "Neues Passwort*",
                  autocomplete: "new-password",
                  required: ""
                }, null, 8, _hoisted_38), [
                  [_vModelText, form.confirmPassword]
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).confirmPassword.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, [
                    _createElementVNode("div", _hoisted_39, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ], 2)
            ]),
            _createVNode(_unref(Error), {
              errorLoc: _unref(ErrorLocationType).form,
              class: "mt-4"
            }, null, 8, ["errorLoc"]),
            _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("button", {
              disabled: loading.value,
              onClick: resetPassword,
              class: _normalizeClass(["btn", loading.value ? 'disabled' : 'primary'])
            }, [
              _createVNode(TextOrSpinner, {
                text: _unref($t)('account.passwordResetButton'),
                spin: loading.value
              }, null, 8, ["text", "spin"])
            ], 10, _hoisted_40),
            _createElementVNode("div", _hoisted_41, _toDisplayString(_unref($t)('account.lastPasswordChangeText')) + ": " + _toDisplayString(passwordChangedMoment.value), 1)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", {
              innerHTML: _unref($t)('login.tabs.changePassword.newPasswordDescription')
            }, null, 8, _hoisted_43)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "btn primary",
              onClick: logoutUser
            }, _toDisplayString(_unref($t)('account.logout')), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})